import { render, staticRenderFns } from "./UpdateResourceField.vue?vue&type=template&id=2d5ad6ed"
import script from "./UpdateResourceField.vue?vue&type=script&lang=js"
export * from "./UpdateResourceField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports